import useAsync from 'react-use/esm/useAsync';
import { workflowApiRef } from '../../../api';
import { useApi, useRouteRefParams } from '@backstage/core-plugin-api';
import { buildRouteRef } from '../../../routes';
import { useEntity } from '@backstage/plugin-catalog-react';
import { stringifyEntityRef } from '@backstage/catalog-model';

export const useWorkflowRunsDetails = (projectId: string, location: string) => {
  const api = useApi(workflowApiRef);
  const { entity } = useEntity();
  const { id } = useRouteRefParams(buildRouteRef);
  const details = useAsync(async () => {
    return projectId
      ? api.getWorkflowRun({
          projectId,
          location,
          id: id,
          entityRef: stringifyEntityRef(entity),
        })
      : Promise.reject('No projectId provided');
  }, [projectId, id]);
  return details;
};
